import { PotentialOffer } from '../types';
import { Negotiation } from '../models/negotiation';

/**
 * Merge vehicle-level negotiations with embedded offer.negotiations from list/detail APIs.
 * GET /vehicle/:id sometimes omits `negotiations` while potential-offers payloads still include them.
 */
export function resolveNegotiationForOffer(
  offer: PotentialOffer,
  vehicleNegotiations: Negotiation[] | undefined
): Negotiation | undefined {
  const fromVehicle = vehicleNegotiations?.find((n) => n.offer_id === offer.id);
  if (fromVehicle) return fromVehicle;

  const fromOffer = offer.negotiations?.find((n) => n.offer_id === offer.id);
  if (fromOffer) return fromOffer;

  if (offer.negotiations?.length === 1) {
    return offer.negotiations[0];
  }

  return undefined;
}

export function resolveNegotiationIdForOffer(
  offer: PotentialOffer,
  negotiation: Negotiation | undefined
): string | number | undefined {
  const nid = negotiation?.id;
  if (nid !== undefined && nid !== null && String(nid) !== '') {
    return nid;
  }
  if (offer.negotiation_id !== undefined && offer.negotiation_id !== null) {
    return offer.negotiation_id;
  }
  return undefined;
}
